<template>
    <div class="product-creator flex justify-center items-center w-full max-w-screen-xl h-full mx-auto px-6 py-12">
        <div class="w-full lg:w-2/3 grid grid-cols-2 gap-8 lg:gap-16">

            <div v-for="type in types" :key="type.key">
                <div class="h-48 mb-8 bg-contain bg-no-repeat bg-center" :style="{ backgroundImage: 'url(' + type.image + ')' }"></div>
                <div class="mb-12 text-center">{{ type.text }}</div>
                <Button class="w-full" @click="select(type.key)">
                    {{ __('home::orders.select') }} 
                    <ChevronRightIcon class="h-4 w-4 ml-2" />
                </Button>
            </div>

        </div>    
    </div>
</template>

<script>
    import axios from 'axios'

    import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            type: String,
            order: Object,
        },
        data() {
            return {
                types: [
                    {
                        key: 'single',
                        text: 'Enkeltstående billeder',
                        image: this.getImage('single'),
                    },
                    {
                        key: 'multiple',
                        text: 'Billede delt på flere tiles',
                        image: this.getImage('multiple'),
                    },
                ],
            }
        },
        methods: {
            getImage(variant) {

                var shape = this.order.meta && this.order.meta['product'] 
                    ? this.order.meta['product'] 
                    : 1;

                var images = {
                    single: {
                        3: 'single-square.png',
                        1: 'single-hexagon.png',
                        9: 'single-frame.png',
                    },
                    multiple: {
                        3: 'multiple-square.png',
                        1: 'multiple-hexagon.png',
                        9: 'multiple-frame.png',
                    },
                };

                return '/media/examples/' + images[variant][shape];
            },
            select(type) {
                
                let request = {
                    type: type,
                };

                axios
                    .patch(this.$route('home::orders.update', { uuid: this.order.uuid }), request)
                    .then((res) => {
                        this.$emit('update:type', type);
                    });
            },
        },
    }
</script>